<template>

  <InfoCreditoDaGestire />

</template>

<script>
import InfoCreditoDaGestire from '../components/ask/pages/InfoCreditoDaGestire.vue'

export default {
  pageName: 'InfoCreditoDaGestire',
  components: {
    InfoCreditoDaGestire

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
